/**
 * Donation Progress State
 *
 * Centralized per-event donation progress state. Uses Signal.State so that
 * the donation modal, banner progress bar, and config panel all react to
 * the same source of truth (RPC initial load + SSE pushes).
 */

import { Signal } from "@lit-labs/signals";
import type { IWritableDonationProgressState, DonationProgress } from "./types";

export class DonationProgressState implements IWritableDonationProgressState {
  readonly progress = new Signal.State<Map<string, DonationProgress>>(new Map());
  readonly loading = new Signal.State<Set<string>>(new Set());

  getProgress(liveEventId: string | undefined): DonationProgress | undefined {
    if (!liveEventId) return undefined;
    return this.progress.get().get(liveEventId);
  }

  isLoading(liveEventId: string | undefined): boolean {
    if (!liveEventId) return false;
    return this.loading.get().has(liveEventId);
  }
}
